module.exports = __webpack_public_path__ + "img/141.0a188ea1.jpg";